import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { CommonButton, CommonModal } from "../Input";
import DetailField from "../Customers/CustomerDetails/DetailField";

const SectionContainer = ({ title, children, extra }) => (
  <div className="mb-4">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h6 className="fw-bold mb-0 fs-14 text-black">{title}</h6>
      {extra}
    </div>
    <div className="rounded-2 p-4 bg-body">
      <Row className="gy-3">{children}</Row>
    </div>
  </div>
);

const TransactionDetailsModal = ({ show, onHide, transaction }) => {
  if (!transaction) return null;

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      size="xl"
      title={
        <div>
          <h4 className="fw-bold text-black mb-1">Transaction Details</h4>
          <p className="fs-13 text-muted mb-0 fw-normal">
            Full report of the transaction including sender and receiver info
          </p>
        </div>
      }
      className="modal-premium"
      modalProps={{ centered: true }}
      footer={null}
    >
      <div className="px-1 py-1">
        {/* Sender Section */}
        <SectionContainer title="Sender">
          <Col md={2} sm={4}>
            <DetailField label="Customer Type" value="Organization" />
          </Col>
          <Col md={3} sm={8}>
            <DetailField
              label="Sender Name"
              value="SparkMinds Technology Pte Ltd"
            />
          </Col>
          <Col md={2} sm={4}>
            <DetailField label="Customer ID" value="10844" />
          </Col>
          <Col md={3} sm={4}>
            <DetailField label="ID Type" value="NRIC (Permanent Resident)" />
          </Col>
          <Col md={2} sm={4}>
            <DetailField label="ID Number" value="S1234567A013" />
          </Col>
        </SectionContainer>

        {/* Beneficiaries Content */}
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="fw-bold mb-0 fs-14 text-black">Beneficiaries</h6>
            <Badge
              bg="warning"
              className="bg-opacity-10 text-warning border-0 px-2 py-1 fw-bold fs-10 text-uppercase rounded-1"
              style={{ letterSpacing: "0.5px" }}
            >
              Waiting for approval
            </Badge>
          </div>

          <div className="rounded-2 p-4 bg-body">
            <Row>
              <Col lg={8} className="border-end border-light pe-lg-4">
                <Row className="gy-3">
                  <Col md={4} sm={6}>
                    <DetailField
                      label="Transaction ID"
                      value="100006686"
                      showCopy={true}
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField
                      label="Created Date & Time"
                      value="06/03/2026 18:38:32"
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Receiver Name" value="SparkMinds" />
                  </Col>

                  <Col md={4} sm={6}>
                    <DetailField label="Receiver Type" value="Individual" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField
                      label="Receiving Method"
                      value="Bank Transfer"
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Bank/Agent" value="OMNIPAY, INC." />
                  </Col>

                  <Col md={4} sm={6}>
                    <DetailField label="Country" value="Philippines" />
                  </Col>
                  <Col md={4} sm={12}>
                    <DetailField
                      label="Account No/IBAN"
                      value="0552000003601"
                      showCopy={true}
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Address" value="--" />
                  </Col>

                  <Col md={4} sm={6}>
                    <DetailField label="IFSC Code" value="--" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField
                      label="Purpose of Transfer"
                      value="Loan Repayment"
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Source of Funds" value="Business" />
                  </Col>
                </Row>
              </Col>
              <Col lg={4} className="ps-lg-4 mt-4 mt-lg-0">
                <div className="bg-white rounded-3 p-3 border border-light">
                  <h6
                    className="fw-bold text-muted text-uppercase mb-3"
                    style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                  >
                    Amount Details
                  </h6>
                  {[
                    { label: "Receiving Amount", value: "400.95 PHP" },
                    { label: "Exchange Rate", value: "1 SGD = 36.45 PHP" },
                    { label: "Send Amount", value: "11.00 SGD" },
                    { label: "Service Charge", value: "6.00 SGD" },
                    { label: "Promo Code", value: "0.00 SGD" },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom border-light border-opacity-50"
                    >
                      <span className="text-muted fs-12">{item.label}</span>
                      <span className="fw-bold text-black fs-12">
                        {item.value}
                      </span>
                    </div>
                  ))}
                  <div className="d-flex justify-content-between mt-3 pt-2">
                    <span className="text-black fw-bold fs-13">
                      Total Amount
                    </span>
                    <span className="fw-bold text-primary fs-15">
                      17.00 SGD
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Invoices Section */}
        <SectionContainer
          title="Invoices"
          extra={
            <span className="fw-bold text-primary fs-14">
              Total to Pay: 17.00 SGD
            </span>
          }
        >
          <Col md={12}>
            <div
              className="bg-light bg-opacity-50 p-4 d-flex align-items-center justify-content-center border rounded-3 overflow-hidden"
              style={{ minHeight: "200px" }}
            >
              <img
                src="https://images.unsplash.com/photo-1554224155-169641357599?auto=format&fit=crop&w=800&q=80"
                alt="Invoice"
                className="img-fluid rounded shadow-sm border"
                style={{ maxHeight: "300px", objectFit: "contain" }}
              />
            </div>
          </Col>
        </SectionContainer>
      </div>
    </CommonModal>
  );
};

export default TransactionDetailsModal;
